import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/base/SEOMeta';
import ScrollToTop from '@/components/base/ScrollToTop';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import HotTopics from './components/HotTopics';
import FeaturedPosts from './components/FeaturedPosts';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '海角社区',
    url: 'https://baynetwork.github.io',
    description: '海角社区是一个开放、包容的在线交流社区，汇聚来自五湖四海的用户，分享生活、情感、兴趣与故事。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://baynetwork.github.io/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '海角社区',
    url: 'https://baynetwork.github.io',
    description: '连接你我的温暖交流平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'hello@haijiao.shequn.cn',
      contactType: 'customer service',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title="连接你我的温暖交流平台"
        description="海角社区是一个开放、包容的在线交流社区，汇聚来自五湖四海的用户，分享生活、情感、兴趣与故事。加入海角社区，找到志同道合的朋友，畅所欲言，感受真实的人与人之间的温度与连接。"
        keywords="海角社区,海角社区官网,海角社区论坛,海角社区注册,海角社区入口,海角社区交流平台,在线社区论坛"
        canonicalUrl="https://baynetwork.github.io/"
      />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <article>
            <Hero />
            <CategoryGrid />
            <section className="py-14 md:py-20 bg-background-100">
              <div className="max-w-7xl mx-auto px-4 md:px-6">
                <div className="flex items-center justify-between mb-10">
                  <div>
                    <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                      精选文章
                    </h2>
                    <p className="text-foreground-600 text-sm">社区编辑为你精选的优质内容</p>
                  </div>
                  <a
                    href="/category/life"
                    className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
                  >
                    查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                  </a>
                </div>
                <div className="flex flex-col lg:flex-row gap-8">
                  <div className="flex-1 min-w-0">
                    <FeaturedPosts />
                  </div>
                  <div className="w-full lg:w-72 flex-shrink-0">
                    <HotTopics />
                  </div>
                </div>
              </div>
            </section>
          </article>

          {/* Community CTA */}
          <section className="py-16 md:py-24 relative overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20abstract%20background%20with%20soft%20overlapping%20circles%20and%20organic%20shapes%20in%20warm%20terracotta%20amber%20and%20cream%20tones%2C%20community%20connection%20concept%2C%20minimalist%20modern%20design%2C%20gentle%20gradients&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
                alt="加入海角社区"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-black/25"></div>
            </div>
            <div className="relative z-10 max-w-3xl mx-auto text-center px-4 md:px-6">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
                准备好开始你的社区之旅了吗？
              </h2>
              <p className="text-white/80 mb-8 leading-relaxed">
                加入海角社区，与来自五湖四海的朋友一起分享生活中的每一个精彩瞬间。无论你是想倾诉心声，还是寻找灵感，这里都有属于你的位置。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="/about#contact"
                  className="px-8 py-3 bg-primary-500 text-white rounded-full text-base font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
                >
                  立即加入
                </a>
                <a
                  href="/category/hobby"
                  className="px-8 py-3 border border-white/40 text-white rounded-full text-base font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
                >
                  浏览兴趣圈子
                </a>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}